import {
  Button,
  Input,
  MantineProvider,
  createTheme,
  rem,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { NavigationProgress } from "@mantine/nprogress";
import "@mantine/nprogress/styles.css";
import "dayjs/locale/vi";

// Chỉ import các module của bản Community (Miễn phí)
import {
  AllCommunityModule,
  ModuleRegistry,
  provideGlobalGridOptions,
} from "ag-grid-community";
import { AgCharts } from "ag-charts-react";

import { Provider } from "react-redux";
import { store } from "./views/Sell/RetailOrder/ReduxToolkit/store";

// Chỉ đăng ký Community Module
ModuleRegistry.registerModules([AllCommunityModule]);

// Cảnh báo "ResizeObserver loop completed with undelivered notifications" của trình duyệt là vô hại (xảy ra khi một ô lưới
// chứa MultiSelect / dropdown đổi kích thước trong cùng khung hình), nhưng lớp phủ lỗi của dev server hiện nó thành lỗi đỏ
// che cả trang. Chặn đúng cảnh báo này trước lớp phủ (lắng nghe ở pha capture, dừng lan truyền); lỗi khác vẫn hiện như thường.
// Bản build không có lớp phủ nên không ảnh hưởng gì
window.addEventListener(
  "error",
  (event) => {
    if (typeof event.message === "string" && event.message.includes("ResizeObserver loop")) {
      event.stopImmediatePropagation();
    }
  },
  true,
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const theme = createTheme({
  fontSizes: {
    xs: rem(10),
    sm: rem(12),
    md: rem(14),
    lg: rem(16),
    xl: rem(20),
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65",
  },
  components: {
    Button: Button.extend({
      defaultProps: {
        color: "cyan",
        variant: "outline",
      },
    }),
  },
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          <NavigationProgress />
          <Notifications position="top-center" autoClose={1500} />
          <App />
        </ModalsProvider>
      </MantineProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
